import { CircularProgress, styled, Tooltip } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { StyledTooltip } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
import { PencilIcon } from '@room-match/shared-ui-components';

const EditCont = styled('div')(() => ({
  backgroundColor: COLORS.PRIMARY,
  position: 'absolute',
  bottom: '5px',
  left: '5px',
  display: 'flex',
  padding: 5,
  borderRadius: 3,
  zIndex: 10,
}));

const RenderEditButton2 = ({ onClickEdit, showLoader = false }: { onClickEdit: () => void; showLoader?: boolean }) => {
  const [isLoading, setIsLoading] = useState(showLoader);

  const onClickEditButton = useCallback(() => {
    onClickEdit();
    setIsLoading(!isLoading);
  }, [isLoading, setIsLoading, onClickEdit]);

  return (
    <Tooltip title={'Edit Image'}>
      <EditCont onClick={() => onClickEditButton()}>
        {isLoading ? (
          <CircularProgress size={15} style={{ color: 'white' }} />
        ) : (
          <PencilIcon htmlColor="white" style={{ width: 15, height: 15 }} />
        )}
      </EditCont>
    </Tooltip>
  );
};

export default RenderEditButton2;
export { RenderEditButton2 };
